import React, { useState, useRef, useEffect } from "react";

const CustomDropdown = ({ trigger, menu, alignRight = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const positionClass = alignRight ? "tw-right-0" : "tw-left-0";

  return (
    <div className="tw-relative tw-inline-block" ref={dropdownRef}>
      <div onClick={toggleDropdown} className="tw-cursor-pointer">
        {trigger}
      </div>

      {isOpen && (
        <ul
          className={`
            tw-absolute 
            tw-mt-2 
            tw-w-max 
            tw-min-w-[150px] 
            tw-bg-white 
            tw-rounded-lg 
            tw-shadow-xl 
            tw-py-1 
            tw-z-50 
            tw-list-none
            tw-p-0 
            tw-m-0
            ${positionClass} 
            tw-border tw-border-gray-200
          `}
          style={{
            top: "100%",
          }}
        >
          {menu}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
